import script from './component-lib.esm2.js';
import normalizeComponent from '../../external/vue-runtime-helpers/dist/component-lib.esm.js';
import createInjector from '../../external/vue-runtime-helpers/dist/inject-style/component-lib.esm.js';

/* script */
const __vue_script__ = script;

/* template */
var __vue_render__ = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c(_vm.buttonTag, _vm._g(_vm._b({
    tag: "component",
    staticClass: "v-inline-link",
    style: _vm.styles,
    attrs: {
      "disabled": _vm.disabled,
      "type": _vm.buttonType
    }
  }, 'component', _vm.$attrs, false), _vm.$listeners), [_c('span', {
    staticClass: "v-inline-link__content"
  }, [_vm._t("default")], 2)]);
};
var __vue_staticRenderFns__ = [];

/* style */
const __vue_inject_styles__ = function (inject) {
  if (!inject) return;
  inject("data-v-382dd9ae_0", {
    source: ".v-inline-link[data-v-382dd9ae]{background:0 0;border:none;cursor:pointer;display:inline-block;color:var(--c-color);font-weight:700;font-size:inherit;font-family:inherit;padding:0;text-decoration:underline;transition:.3s cubic-bezier(.25,.8,.5,1)}.v-inline-link[data-v-382dd9ae]:focus,.v-inline-link[data-v-382dd9ae]:hover{background:0 0;color:var(--c-color)}.v-inline-link[data-v-382dd9ae]:disabled,.v-inline-link[disabled][data-v-382dd9ae]{background-color:none;color:var(--c-color-disabled);opacity:.8;pointer-events:none}.v-inline-link__content[data-v-382dd9ae]{align-items:center;display:flex}",
    map: undefined,
    media: undefined
  });
};
/* scoped */
const __vue_scope_id__ = "data-v-382dd9ae";
/* module identifier */
const __vue_module_identifier__ = undefined;
/* functional template */
const __vue_is_functional_template__ = false;
/* style inject SSR */

/* style inject shadow dom */

const __vue_component__ = /*#__PURE__*/normalizeComponent({
  render: __vue_render__,
  staticRenderFns: __vue_staticRenderFns__
}, __vue_inject_styles__, __vue_script__, __vue_scope_id__, __vue_is_functional_template__, __vue_module_identifier__, false, createInjector, undefined, undefined);
var InlineLink = __vue_component__;
export { InlineLink as default };